import { QuickFinderGroupDialog } from 'app/components/QuickFinderGroupDialog';
import { Button, Typography } from 'app/design';
import { useGroupQuery } from 'app/hooks/queries/group';
import { useToggleReducer } from 'app/utilities';
import React from 'react';
import { useFormContext } from 'react-hook-form';

// interface declaring which props are required/allowed
// interface GroupProps {
//   // directoryId: string;
//   callflow?: any;
//   open?: boolean;
//   onCancel: () => void;
//   // onComplete: () => void;
// }

const Group = ({ item, modifyPath, onChangeSimple, ...rest }) => {
  console.log('Group:', { item, modifyPath, rest });
  const { varItem, moduleItem, moduleModifyPath } = item;
  const {
    register,
    formState: { errors: formErrors, isDirty, dirtyFields },
    setError,
    watch,
    control,
    setValue,
  } = useFormContext();

  const [showFinderDialog, toggleShowFindDialog] = useToggleReducer(false);

  const key = varItem.key;
  const variables = watch(`${modifyPath}callflow.strategy.simple.variables`);

  // simple variable values
  const currentVarOutputValue = varItem.output_value;
  const defaultValueInFlow = varItem.output_value_default;
  const simpleValueInCallflow = variables[key];

  // get CURRENT value FROM MODULE
  // - for when saved by the Advanced Editor!
  //   - that doesnt update the varItem, it only updates the actual flow!
  const currentValue = moduleItem?.data?.data?.id;

  const {
    data: groupCurrent,
    isLoading: groupCurrentIsLoading,
    isFetched: groupCurrentIsFetched,
  } = useGroupQuery(currentValue);

  const {
    data: groupSimple,
    isLoading: groupSimpleIsLoading,
    isFetched: groupSimpleIsFetched,
  } = useGroupQuery(simpleValueInCallflow);

  const onChangeSelect = selected => {
    const [groupId] = selected;
    setValue(
      `${modifyPath}callflow.strategy.simple.variables.${key}`,
      groupId,
      {
        shouldDirty: true,
      },
    );
    // TODO: this may work for "account no_schedule" but may fail at others, need to verify
    // - we're doing this so that the "simple" value is applied immediately!
    //   - maybe should emit an event that rebuilds, instead?
    setValue(`${modifyPath}callflow${moduleModifyPath}.data.data.id`, groupId, {
      shouldDirty: true,
    });
    onChangeSimple && onChangeSimple();

    // setAtPath(tmpModuleItem, `data.id`, groupId); // newValue?.value === id
    // setModifyModuleItem({ ...tmpModuleItem });
    toggleShowFindDialog();
  };

  const handleClear = () => {
    // setAtPath(tmpModuleItem, `data.id`, null); // newValue?.value === id
    // setModifyModuleItem({ ...tmpModuleItem });
    // toggleShowFindDialog();
  };

  console.log('varitem Group:', varItem, {
    currentValue,
    simpleValueInCallflow,
    callflow: watch(`${modifyPath}callflow`),
  });

  return (
    <div>
      {showFinderDialog ? (
        <QuickFinderGroupDialog
          onSelect={onChangeSelect}
          onCancel={toggleShowFindDialog}
          onClear={handleClear}
          initialSelected={simpleValueInCallflow ? [simpleValueInCallflow] : []}
          selectionTitle={groupSimple ? `${groupSimple.doc.name}` : null}
          allowSelectNone
        />
      ) : null}
      <Typography variant="h3">Group:</Typography>

      <Typography variant="bodyBig" sx={{ fontWeight: 'bold' }} paragraph>
        {groupCurrentIsLoading
          ? 'Loading...'
          : groupCurrent
          ? groupCurrent.doc?.name ?? 'Invalid group'
          : 'None set'}
      </Typography>

      <Button
        color="primary"
        variant="outlined"
        size="small"
        onClick={toggleShowFindDialog}
      >
        Change Group
      </Button>
      {/* <Typography variant="body1">
        Current:{' '}
        {groupCurrentIsLoading
          ? 'Loading...'
          : groupCurrent
          ? groupCurrent.extra?.fullName ?? 'Invalid group'
          : 'None set'}
      </Typography>
      <Typography variant="body1" onClick={toggleShowFindDialog}>
        Custom:
        {groupSimpleIsLoading
          ? 'Loading...'
          : groupSimple
          ? groupSimple.extra?.fullName ?? 'Invalid group'
          : 'None set'}
      </Typography> */}
    </div>
  );
};

export default Group;
